import { BlobModel } from '@/models/blob';
import { signedApiClient } from '@/services/apiClient';

class BlobService {
  private blobEndpoint: string = '';
  initService(blobEndpoint: string) {
    this.blobEndpoint = blobEndpoint;
  }

  async patchBlob(identifier: string): Promise<BlobModel> {
    const uri = `${this.blobEndpoint}/${identifier}`;
    const apiClient = signedApiClient('PATCH', uri);
    return (await apiClient.patch(uri)).data;
  }

  async getBlobMetadata(identifier: string) {
    const uri = `${this.blobEndpoint}/${identifier}/metadata`;
    const apiClient = signedApiClient('GET', uri);
    const blob = await apiClient.get(uri);
    const blobModel =  BlobModel.mapFromBackend(blob.data);
    if (blobModel.hasThumbnail) {
      blobModel.thumbnailKey = await this.downloadBlob(identifier, true, blobModel.name);
    }
    return blobModel;
  }

  async downloadBlob(identifier: string, thumbnail?: boolean, name?: string, fullResolution?: boolean) {
    let uri = `${this.blobEndpoint}/${identifier}`;
    if (thumbnail) {
      uri += '/thumbnail';
    }
    const apiClient = signedApiClient('GET', uri);
    apiClient.defaults.responseType = 'blob';
    const blob = await apiClient.get(uri);
    delete apiClient.defaults.responseType;
    const filename = name ? name : decodeURIComponent(
      blob.headers['content-disposition']
        .replace('attachment; filename=', '')
        .slice(1, -1)
    );
    const filetype = blob.headers['content-type'];
    const systemBlob = new Blob([blob.data]);
    const file = new File([systemBlob], filename, { type: filetype });
    const url = window.URL.createObjectURL(file);

    if (thumbnail) {
      return url;
    }

    if (fullResolution) {
      return url;
    }

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode?.removeChild(link);
  }
}

export default new BlobService();
